var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"65d6e4d8a96b2b54989b36a15bf39d9b7b5c52f5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["no-loss@hardpixel"]={id:"65d6e4d8a96b2b54989b36a15bf39d9b7b5c52f5"};
      